import { render, staticRenderFns } from "./DownUpTabs.vue?vue&type=template&id=24917699&"
import script from "./DownUpTabs.vue?vue&type=script&lang=js&"
export * from "./DownUpTabs.vue?vue&type=script&lang=js&"
import style0 from "./DownUpTabs.vue?vue&type=style&index=0&id=24917699&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports